export default __webpack_public_path__ + "media/images/images_v2/right-pagination-dc9ad277bf42cb69ed806d0dc90cb80c.png";